module.exports = __webpack_public_path__ + "static/media/quts.71f8020d.svg";